
import {Component, Vue} from "vue-property-decorator";
import {getPageAPIs, Util} from "@/common/util";
import PoolTableListAPIClass from "@/common/api/poolTableList";

export const pageApiList = getPageAPIs(PoolTableListAPIClass);

@Component({})
export default class UserList extends Vue {
  private apiClass: any = new PoolTableListAPIClass();
  private visible: boolean = false;
  private form: any = {
    name: ''
  };
  private add_form: any = {
    id: '',
    name: '',
    daytime_price: '',
    nighttime_price: '',
    serial_number: '',
    is_status: null,
    pool_table_category_id: ''
  };

  private activated(): void {
    this.getTable();
  }

  private created() {
    this.getCategoryList()
  }

  private getTable(): void {
    this.apiClass.getList(
        {
          ...this.form,
          page: this.tablePage.pageNo,
          limit: this.tablePage.pageSize,
        },
        (res: any) => {
          this.tableData = res.data.list;
          this.tablePage.totalCount = res.data.count;
          this.tablePage.pageNo = res.data.page;
          this.tablePage.pageSize = res.data.prepage;
        }
    );
  }

  private getCategoryList(): void {
    this.apiClass.getCategory(
        {}, (res: any) => {
          console.log('球桌分类', res)
          this.pool_type_options = res.data.list
        }
    );
  }

  private add_submit(): void {
    this.$refs['ruleForm'].validate((valid) => {
      if (valid) {
        this.apiClass.save(this.add_form, (res: any) => {
          Util.showToast("编辑成功");
          this.getTable()
          this.visible = false;
        }, () => {
        })
      }
    });

  }

  private restForm(): void {
    this.form = new Util().clearObject(this.form);
    this.getTable();
  }

  private search(): void {
    this.tablePage.pageNo = 1;
    this.tableData = [];
    this.tablePage.totalCount = 0;
    this.getTable();
  }

  private tableData: any[] = [];
  private tablePage: any = {
    totalCount: 0,
    pageNo: 1,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100, 200, 500],
  };
  private rules: any = {
    phone: [
      {required: false, message: '请输入手机号', trigger: 'blur'},
    ],
    remark: [
      {required: false, message: '原因必填', trigger: 'blur'},
    ],
  }
  private pool_type_options: any[] = []

  private handlePageChange(val: any) {
    this.tablePage.pageNo = val.currentPage;
    this.tablePage.pageSize = val.pageSize;
    this.getTable();
  }

  private onEdit(row: any): void {
    console.log(row)
    this.add_form = {...row}
    this.visible = true
  }

}
